import React, { useState, useRef } from 'react';
import {
  Box,
  Flex,
  Heading,
  Input,
  Button,
  Text,
  VStack,
  SimpleGrid,
  Image,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useToast,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  IconButton,
} from '@chakra-ui/react';
import {
  CheckCircleIcon,
  ChevronDownIcon,
  Icon,
  SearchIcon,
  WarningIcon,
} from '@chakra-ui/icons';
import { loadStripe } from '@stripe/stripe-js';
import {
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useBreakpointValue,
} from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';
import TerminosCondiciones from './TerminosCondiciones';
import AvisoPrivacidad from './AvisoPrivacidad';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import TablaLicenciasConDashboard from './TablaLicenciasConDashboard';
import DashboardLicencias from './DashboardLicencias';
import { MdAdd } from 'react-icons/md';
import ModalSolicitud from './ModalSolicitud';
const stripePromise = loadStripe(
  'pk_test_51I36nsKFjLyegMZ0PBzyG10mY96fE1LypK6GTZhvkWvzqfRsgFDtpglIoRqLNsXVK7zpTKGXEB2XPnhuE7CqG3hC00mFvPFjhm',
);

interface Tramite {
  ID: string;
  Concepto: string;
  estatus_pago: string;
  Monto: number;
}


const PortalCiudadano: React.FC = () => {
  const [activeModal, setActiveModal] = useState<string | null>(null);
//   const { isOpen, onOpen, onClose } = useDisclosure();
//   const [archivos, setArchivos] = useState({ recibo: undefined, fotos: [] });

//   const handleArchivoChange = (e, tipo, multiple = false) => {
//     const files = e.target.files;
//     if (multiple) {
//       setArchivos((prev) => ({ ...prev, [tipo]: Array.from(files) }));
//     } else {
//       setArchivos((prev) => ({ ...prev, [tipo]: files?.[0] }));
//     }
//   };

  const tiposDeTramite = [
    "Temporal",
    "Anual",
    "Renovación",
    "Cancelación",
    "Cambio de giro",
    "Cambio de propietario",
  ];
  const [archivos, setArchivos] = useState({
    solicitud: null,
    recibo: null,
    croquis: null,
    domicilio: null,
    fotos: null,
    dictamen: null,
  });
  
  const { isOpen, onOpen, onClose } = useDisclosure();
  const isMobile = useBreakpointValue({ base: true, md: false });
  const {
    isOpen: isDrawerOpen,
    onOpen: onDrawerOpen,
    onClose: onDrawerClose,
  } = useDisclosure();
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const openModal = (section: string) => {
    setActiveModal(section);
    onOpen();
  };

  const handleArchivoChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    tipo: string,
    multiple = false
  ) => {
    const files = e.target.files;
    if (!files) return;
  
    setArchivos((prev) => ({
      ...prev,
      [tipo]: multiple ? Array.from(files) : files[0],
    }));
  };
  
  
  const handleBurgerClick = () => {
    setActiveModal('Menú Principal');
    onOpen(); // Abre el modal
    onDrawerOpen(); // Abre el Drawer
  };

  const closeModal = () => {
    setActiveModal(null);
    onClose();
  };

  const menuItems = [
    'Secretaría',
    'Trámites en Línea',
    'Pagos',
    'Adeudos',
    'Certificaciones',
    'Recibos de Pago',
    'Devoluciones',
  ];

  // Configuración del Carousel
  const settings = {
    dots: true, // Indicadores de posición
    infinite: true, // Carrusel infinito
    speed: 500, // Velocidad de transición
    slidesToShow: 1, // Imágenes mostradas a la vez
    slidesToScroll: 1, // Imágenes que se desplazan
    autoplay: true, // Deslizamiento automático
    autoplaySpeed: 4000, // Tiempo entre cada desplazamiento
  };

  const servicios = [
    {
      title: 'Pago de Predial',
      description: 'Mantén al día tus pagos del impuesto predial.',
      img: 'https://images.unsplash.com/photo-1499916078039-922301b0eb9b?q=80&w=1780&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    },
    {
      title: 'Pago de Agua',
      description: 'Regulariza tu servicio de agua potable.',
      img: 'https://images.unsplash.com/photo-1542397284385-6010376c5337?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    },
    {
      title: 'Multas de Tránsito',
      description: 'Consulta y paga tus multas rápidamente.',
      img: 'https://plus.unsplash.com/premium_photo-1687948178367-a1155771044b?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    },
  ];

  const [ineId, setIneId] = useState('');
  const [tramites, setTramites] = useState<Tramite[]>([]);
  const toast = useToast();
  const tramitesRef = useRef<HTMLDivElement>(null);

  const buscarTramites = async () => {
    if (!ineId) {
      toast({
        title: 'Error',
        description: 'Por favor introduce un ID de INE válido.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      const response = await fetch(`http://52.91.130.91:5000/api/Transacciones/rfc/${ineId}`);
      const data = await response.json();

      if (!data || data.length === 0) {
        toast({
          title: 'Sin resultados',
          description: 'No se encontraron trámites para este RFC.',
          status: 'info',
          duration: 3000,
          isClosable: true,
        });
        setTramites([]);
        tramitesRef.current?.scrollIntoView({ behavior: 'smooth' });

      } else {
        setTramites(data);
        tramitesRef.current?.scrollIntoView({ behavior: 'smooth' });
      }
    } catch (error) {
      console.error(error);
      toast({
        title: 'Error',
        description: 'Hubo un problema al consultar la API. Intenta de nuevo.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }


    // const datos = dummyData[ineId];
    // if (!datos) {
    //   toast({
    //     title: 'Sin resultados',
    //     description: 'No se encontraron trámites para este ID del INE.',
    //     status: 'info',
    //     duration: 3000,
    //     isClosable: true,
    //   });
    //   setTramites([]);
    // } else {
    //   setTramites(datos);
    //   // Desplazar automáticamente hacia la sección de trámites
    //   tramitesRef.current?.scrollIntoView({ behavior: 'smooth' });
    // }
  };

  const handlePago = async (tramiteId: string, monto: number) => {
    try {
      const stripe = await stripePromise;
      if (!stripe) {
        throw new Error('Stripe no está disponible.');
      }

      const response = await fetch(
        'http://52.91.130.91:5000/api/stripe/create-session',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ tramiteId, monto, ineId }),
        },
      );

      const data = await response.json();
      if (data.error) throw new Error(data.error);

      await stripe.redirectToCheckout({ sessionId: data.sessionId });
    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudo procesar el pago. Intenta de nuevo.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Box>
      {/* Header */}
      <Flex
        bg="white"
        color="gray.800"
        py={2}
        px={8}
        justifyContent="space-between"
        alignItems="center"
        borderBottom="2px solid #D6D6D6"
      >
        
      </Flex>

     
      {/* Drawer para Móviles */}
      {isMobile && (
        <Drawer placement="left" onClose={onDrawerClose} isOpen={isDrawerOpen}>
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader>Navegación</DrawerHeader>
            <DrawerBody>
              {menuItems.map((item) => (
                <Text
                  key={item}
                  fontWeight="bold"
                  my={2}
                  cursor="pointer"
                  _hover={{ color: '#A1263D' }}
                  onClick={() => openModal(item)}
                >
                  {item}
                </Text>
              ))}
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      )}

      {/* Modal */}
      <Modal isOpen={isOpen} onClose={closeModal} size="md">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{activeModal}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
  {tiposDeTramite.includes(activeModal || '') ? (
    <VStack spacing={6} align="stretch">
      <Text fontWeight="bold" fontSize="lg">Datos del Titular</Text>
      <SimpleGrid columns={{ base: 1, md: 1 }} spacing={4}>
        <Input placeholder="Nombre" />
        <Input placeholder="Apellido Paterno" />
        <Input placeholder="Apellido Materno" />
      </SimpleGrid>
      <Input placeholder="INE (número o archivo)" />

      <Text fontWeight="bold" fontSize="lg">Documentación Requerida</Text>
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
      <Box>
  <Text fontSize="sm" mb={1}>Recibo Predial / Agua</Text>
  <Input type="file" accept=".pdf,.jpg,.png"
    onChange={(e) => handleArchivoChange(e, 'recibo')}
  />
  {archivos.recibo && (
    <Text fontSize="xs" mt={1} color="gray.600">
      Archivo seleccionado: {archivos.recibo.name}
    </Text>
  )}
</Box>

<Box>
  <Text fontSize="sm" mb={1}>Fotografías del Establecimiento</Text>
  <Input
    type="file"
    multiple
    accept=".jpg,.png"
    onChange={(e) => handleArchivoChange(e, 'fotos', true)}
  />
  {archivos.fotos && Array.isArray(archivos.fotos) && (
    <Box mt={1}>
      {archivos.fotos.map((file, index) => (
        <Text key={index} fontSize="xs" color="gray.600">
          {file.name}
        </Text>
      ))}
    </Box>
  )}
</Box>


      </SimpleGrid>

      <Button colorScheme="red" mt={6} alignSelf="flex-end">
        Enviar solicitud
      </Button>
    </VStack>
  ) : (
    <Text>Contenido de la sección: {activeModal}</Text>
  )}
</ModalBody>


          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={closeModal}>
              Cerrar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      
      {/* Servicios Destacados */}
      <Box py={10} px={8} bg="gray.100" maxW="1000px" mx="auto">
      

        {/* Carrusel */}
        <Slider {...settings}>
          {servicios.map((servicio, index) => (
            <Box
              key={index}
              bg="white"
              borderRadius="lg"
              shadow="lg"
              textAlign="center"
              overflow="hidden"
            >
              <Image
                src={servicio.img}
                alt={servicio.title}
                borderRadius="lg"
                w="100%"
                h="200px"
                objectFit="cover"
              />
              <Heading size="md" mt={4} color="#A1263D">
                {servicio.title}
              </Heading>
              <Text fontSize="sm" mt={2} px={4} pb={6} color="gray.600">
                {servicio.description}
              </Text>
            </Box>
          ))}
        </Slider>
      </Box>

     <DashboardLicencias></DashboardLicencias>
     <TablaLicenciasConDashboard></TablaLicenciasConDashboard>
      {/* Footer */}
      <Box bg="transparent" color="black" py={10} px={8}>
      <Flex
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        maxW="1200px"
        mx="auto"
      >
        {/* Sección de Atención Ciudadana */}
        <VStack align="flex-start" spacing={2}>
          <Heading size="md">Atención Ciudadana</Heading>
          <Text>
            <strong>Dirección:</strong> Tepetlapa y Nieves, 90160 San Juan
            Totolac, Tlax.
          </Text>
          <Text>
            <strong>Teléfono:</strong> 246 328 0933
          </Text>
          <Text>
            <strong>Correo Electrónico:</strong> ayuntamiento@totolac.gob.mx
          </Text>
        </VStack>

        {/* Sección de Secretaría */}
        <VStack align="flex-end" spacing={2}>
        <Flex justifyContent="flex-end" mt={6} gap={4}>
        <Image src="https://upload.wikimedia.org/wikipedia/commons/0/04/Visa.svg" alt="VISA" boxSize="50px" />
        <Image src="https://upload.wikimedia.org/wikipedia/commons/b/b7/MasterCard_Logo.svg" alt="MasterCard" boxSize="50px" />
        <Image src="https://www.openpay.mx/_ipx/_/img/header/openpay-color.svg" alt="OpenPay" boxSize="60px" />
      </Flex>
        </VStack>
      </Flex>
    {/* Botones para términos y privacidad */}
      <Flex justifyContent="center" mt={6} gap={4}>
        <Button colorScheme="blackAlpha" variant="outline" onClick={() => setIsTermsOpen(true)}>
          Términos y Condiciones
        </Button>
        <Button colorScheme="blackAlpha" variant="outline" onClick={() => setIsPrivacyOpen(true)}>
          Aviso de Privacidad
        </Button>
      </Flex>

      {/* Logos de pago */}
    

      {/* Modal de Términos y Condiciones */}
      <Modal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} size={'2xl'}>
        <ModalOverlay />
        <ModalContent>
          {/* <ModalHeader>Términos y Condiciones</ModalHeader> */}
          <ModalCloseButton />
          <ModalBody>
<TerminosCondiciones></TerminosCondiciones>
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* Modal de Aviso de Privacidad */}
      <Modal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} size={'2xl'}>
        <ModalOverlay />
        <ModalContent>
          {/* <ModalHeader>Aviso de Privacidad</ModalHeader> */}
          <ModalCloseButton />
          <ModalBody>
<AvisoPrivacidad></AvisoPrivacidad>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>

    <IconButton
  onClick={onOpen}
  aria-label="Abrir solicitud"
  icon={<Icon as={MdAdd} h="24px" w="24px" color="white.300" />}
  position="fixed"
  bottom="4"
  right="4"
  zIndex="1000"
  bg="green.300"
  boxShadow="2xl"
  borderRadius="full"
  _hover={{ bg: 'gray.100' }}
/>

<ModalSolicitud
        isOpen={isOpen}
        onClose={onClose}
        archivos={archivos}
        handleArchivoChange={handleArchivoChange}
      />
    </Box>
  );
};

export default PortalCiudadano;
function onDrawerOpen() {
  throw new Error('Function not implemented.');
}
